import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtService } from '../auth/services/jwt.service';

@Injectable({
  providedIn: 'root'
})
export class BaseHttpService {
  constructor(private jwtService: JwtService, public http: HttpClient) {}

  protected getAuthHeaders(): HttpHeaders {
    const token = this.jwtService.getToken();
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }

  protected retrieveAllFromKey<T = any>(url: string, body: Record<string, unknown>) {
    return this.http.post<T[]>(url, body, { headers: this.getAuthHeaders() });
  }

  protected retrieveFromKey<T = any>(url: string, body: Record<string, unknown>) {
    return this.http.post<T>(url, body, { headers: this.getAuthHeaders() });
  }

  protected getUserByToken() {
    return this.jwtService.decodeToken();
  }
}
